/**
 * CustomEvent - Event renderer for calendar cells
 * Shows appointment title, installer name, and creator name
 */
const CustomEvent = ({ event }) => (
  <div className="px-1 py-0.5 overflow-hidden">
    <div className="font-medium text-xs truncate">{event.title}</div>
    {event.installerName && (
      <div className="text-[10px] opacity-90 truncate flex items-center gap-1">
        <span>🔧</span> {event.installerName}
      </div>
    )}
    {event.createdByName && (
      <div className="text-[10px] opacity-80 truncate flex items-center gap-1">
        <span>👤</span> {event.createdByName}
      </div>
    )}
  </div>
);

export default CustomEvent;
